import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const BusFleet: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m750 270v-150h30v120c0 16.57-13.43 30-30 30z' />
    <path d='m210 270v-150s-30 0-30 0v120c0 16.57 13.43 30 30 30z' />
    <path d='m79.37 390h444.2v30h-444.2z' />
    <path d='m76.34 510h444.2v30h-444.2z' />
    <path d='m180 660h240v30h-240z' />
    <path d='m540 695.63h-30v-313.64c0-28.67-24.94-51.99-55.59-51.99h-308.82c-30.65 0-55.59 23.32-55.59 51.99v313.64h-30v-313.64c0-45.21 38.4-81.99 85.59-81.99h308.82c47.19 0 85.59 36.78 85.59 81.99z' />
    <path d='m168.75 780h-108.75v-89.38h30v59.38h78.75c6.2 0 11.25-5.05 11.25-11.25v-59.38h30v59.38c0 22.75-18.5 41.25-41.25 41.25z' />
    <path d='m540 780h-108.75c-22.75 0-41.25-18.5-41.25-41.25v-59.38h30v59.38c0 6.2 5.05 11.25 11.25 11.25h78.75v-59.38h30z' />
    <path d='m265.18 120h444.2v30h-444.2z' />
    <path d='m255 240h451.34v30h-451.34z' />
    <path d='m720 425.63h-30v-313.64c0-28.67-24.94-51.99-55.59-51.99h-308.82c-30.65 0-55.59 23.32-55.59 51.99v158.01h-30v-158.01c0-45.21 38.4-81.99 85.59-81.99h308.82c47.19 0 85.59 36.78 85.59 81.99z' />
    <path d='m720 505h-105c-24.81 0-45-18.5-45-41.25v-73.75h30v73.75c0 6.1 6.87 11.25 15 11.25h75v-59.38h30z' />
    <circle cx='205' cy='600' r='25' />
    <circle cx='395' cy='600' r='25' />
    <circle cx='585' cy='330' r='25' />
    <path d='m30 540v-150s-30 0-30 0v120c0 16.57 13.43 30 30 30z' />
  </IconBase>
));

BusFleet.displayName = 'BusFleet';

export default BusFleet;
